<!--
 * @Author: lishiqiao
 * @Date: 2022-03-11 09:33:39
 * @LastEditors: lishiqiao
 * @LastEditTime: 2022-03-11 10:08:18
-->
<template>
  <div class="page-list">
    <!-- 汇总表-育苗 -->
    <SummaryPage v-if="pageType === 'summary'" @getPageType="getPageType" />
    <!-- 明细表-育苗 -->
    <DetailPage v-if="pageType === 'detail'" @getPageType="getPageType" />
  </div>
</template>

<script>
import SummaryPage from "./ym-sales-volume-summary.vue";
import DetailPage from "./ym-sales-volume-detail.vue";
export default {
  name: "ym-sales-volume",
  data() {
    return {
      pageType: "summary", // summary汇总表,detail明细表
    };
  },
  methods: {
    getPageType(pageType) {
      this.pageType = pageType;
    },
  },
  components: {
    SummaryPage,
    DetailPage,
  },
};
</script>

<style lang="less" scoped>
</style>